import { render, staticRenderFns } from "./seat-map-footer.vue?vue&type=template&id=f534ad32&"
import script from "./seat-map-footer.vue?vue&type=script&lang=js&"
export * from "./seat-map-footer.vue?vue&type=script&lang=js&"
import style0 from "./seat-map-footer.vue?vue&type=style&index=0&id=f534ad32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports